const parseValueForm = (keys: string[], values: any, prefix = '') => {
  const initialValue = {}

  return keys.reduce((obj: any, key: string) => {
    return Object.assign(obj, {
      [key]: values[prefix + key],
    })
  }, initialValue)
}

export { parseValueForm }
